<template>
    <div :id="page_slug">
        <div class="crumbs-bar">
        <el-row>
            <el-col :span="12">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ name: 'ProductTypeList' }">Product Types</el-breadcrumb-item>
                <el-breadcrumb-item>Add</el-breadcrumb-item>
            </el-breadcrumb>        
            </el-col>      
        </el-row>
        </div>

        <el-form
            ref="product_type"
            :rules="rules.product_type"
            :model="product_type"
            :label-position="label_position">

            <el-form-item label="Name" prop="name">
                <el-input v-model="product_type.name"></el-input>
            </el-form-item>
            <el-form-item label="Description" prop="description">
                <el-input v-model="product_type.description"></el-input>
            </el-form-item>
            <el-form-item label="Tax Class:" prop="tax_class_id">
                <el-select 
                    v-model="product_type.tax_class_id" 
                    placeholder="Select Here">
                    <el-option
                    v-for="item in tax_classes"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item> 

            <el-form-item label="Sort Order" prop="sort_order">
                <el-input-number :min="0" v-model="product_type.sort_order"></el-input-number>
            </el-form-item>

        <el-form-item>
            <el-button type="primary" @click="addProductType('product_type')">Add Product Type</el-button>
            </el-form-item>

        </el-form>

        <pre v-if="config.debug">{{$data}}</pre>
    </div>
</template>

<style>

</style>

<script>

    import Config from '@/store/Config.js';
    import Utils from '@/components/utils/Utils.js';
    import Auth from '@/components/auth/AuthCheck.js';

    export default {
        data: function() {
            return {
                config: Config.config,
                page_alias: 'Add Product Type',
                page_slug: 'add-product-type',
                label_position: 'top',
                loading: false,
                rules: {
                    product_type: {
                        name: [
                            {required: true, message: 'Please Enter Product Name', trigger: 'blur'}
                        ],
                        description: [
                            {required: true, message: 'Please Enter Product Description', trigger: 'blur'}
                        ],
                        sort_order: [
                            {required: true, message: 'Please Select Sort Order', trigger: 'blur'}
                        ],
                        tax_class_id: [
                            {required: true, message: '', trigger: 'blur'}
                        ],
                    }
                },

                product_type: {
                    id: '',
                    name: '',
                    description: '',
                    sort_order: '',
                    tax_class_id: '',
                    created_at: '',
                    updated_at: '',
                },

                tax_classes: {
                    
                }
            };  
        },

        mounted: function() {
            const me = this;
            me.getTaxClasses();
        },

        methods: {
            getTaxClasses: function(goToPage) {
                console.log('get tax function');
                const me = this;
                // start the loader
                me.loading = true;
                me.$http.get(me.config.api + 'taxClasses').then(
                    response => {
                    console.log('Success Getting Data')  
                    console.log(response.status);
                    console.log(response.statusText);
                    // get body data
                    me.tax_classes = response.body.data;
                    // end the loader
                    me.loading = false;
                }, response => {
                    console.log('Error Getting Data');
                    console.log(response.status);
                    console.log(response.statusText);
                me.$notify({
                    title: 'Error',
                    message: response.statusText,
                    type: 'error'
                });
                // end the loader
                me.loading = false;
                });
            },

            addProductType: function(formName) {
                console.log('Add Product Type Function');
                const me = this;
                me.$refs[formName].validate((valid) => {
                if (valid) {
                    me.$http.post(me.config.api + 'product-type', me.product_type).then(
                        response => {
                        console.log('Success posting data')  
                        console.log(response.status);
                        console.log(response.statusText);
                        // Success notification 
                        me.$notify({
                            title: 'Success',
                            message: 'The Product Type Was Added',
                            type: 'success'
                        });
                        // Reset the form to prevent double submissions 
                        me.resetForm('product_type');
                        // Redirect to the list page
                        me.$router.push({ name: 'ProductTypeList'});
                        }, response => {
                            console.log('Error posting data');
                            console.log(response.status);
                            console.log(response.statusText);
                        }
                    );
                    } else {
                        console.log('Fields Not Valid');
                        return false;
                    }
                });
            },

            resetForm(formName) {
                const me = this;
                this.$refs[formName].resetFields();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/product-types/ProductTypeAdd.vue